import { API } from 'api/config'
import {
	getTagsInfoResponse,
	ReachDataResponse,
	ReachDataTable
} from 'interfaces/api'
import { captureErrorSentry, SentryEvents, SentrySections } from 'utils/sentry'

export const getReachDetailsBanner = async (
	resourceId: number,
	organizationId: number,
	resourceType: string
): Promise<ReachDataResponse | undefined> => {
	let res = undefined as ReachDataResponse | undefined
	await API()
		.get(
			`/people/reach_details_banner/${resourceId}/organization/${organizationId}?resource_type=${resourceType}`
		)
		.then(
			async response => {
				res = response.data
			},
			error => {
				console.error(error)
				res = error.response.data
			}
		)
	return res
}

export const getReachDataTable = async (
	organizationId: number,
	resourceId: number,
	resourceType: string,
	page: number,
	size: number,
	paginate?: boolean,
	search?: string
): Promise<ReachDataTable | undefined> => {
	let res = undefined as ReachDataTable | undefined
	await API()
		.get(`/people/reach_details/${resourceId}/organization/${organizationId}`, {
			params: {
				page,
				size,
				paginate,
				search,
				resource_type: resourceType
			}
		})
		.then(
			async response => {
				res = response.data
			},
			error => {
				captureErrorSentry({
					section: SentrySections.PEOPLE,
					event: SentryEvents.GET_REACH_DATA_TABLE_ERROR,
					error,
					extra: {
						organizationId,
						resourceId,
						params: {
							page,
							size,
							paginate,
							search,
							resource_type: resourceType
						}
					}
				})
			}
		)
	return res
}

export const getTagsInfo = async (
	tagsIds: number[],
	organizationId: number,
	page: number,
	size: number,
	search?: string
): Promise<getTagsInfoResponse | undefined> => {
	let res = undefined as getTagsInfoResponse | undefined
	await API()
		.get(`/people/users/tags`, {
			params: {
				tags_ids: tagsIds.join(','),
				organization_id: organizationId,
				page,
				size,
				search
			}
		})
		.then(async response => {
			res = response.data
		})
	return res
}
